import styled from "styled-components";
import palette from "../../lib/styles/palette";
import Button from "../common/Button";
import { useSelector } from "react-redux";

const PulleyEstimateActionButtonsBlock = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    margin-top: 5rem;
    margin-bottom: 5rem;
    padding: 0 1rem;
    // display: flex;
    // justify-content: flex-end;
`;

const StyledButton = styled(Button)`
    height: 2.125rem;
    & + & {
        margin-left: 0.5rem;
    }
`;

const PulleyEstimateActionButtons = ({ isEdit, onPublish, onCancel }) => {
    const language = useSelector(state => state.language.language);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;

    const editText = isKR ? '수정' : isJP ? '修正' : isEN ? 'Edit' : '';
    const registerTest = isKR ? '등록' : isJP ? '登録' : isEN ? 'Register' : '';

    return (
        <PulleyEstimateActionButtonsBlock>
            {/* <StyledButton cyan onClick={onPublish}>Pulley {isEdit ? '수정' : '등록'}</StyledButton> */}
            {/* <StyledButton onClick={onCancel}>취소</StyledButton> */}
            <StyledButton cyan onClick={onPublish}>{isKR ? '풀리' : isJP ? 'プーリー' : isEN ? 'Pulley' : ''} {isEdit ? editText : registerTest}</StyledButton>
            <StyledButton onClick={onCancel}>{isKR ? '취소' : isJP ? 'キャンセル' : isEN ? 'Cancel' : ''}</StyledButton>
        </PulleyEstimateActionButtonsBlock>
    );
};

export default PulleyEstimateActionButtons;